var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnyxXBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 850.4 850.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #2563eb;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_147220",
    className: "st0",
    d: "M588.5,504.3c-23.3-23.3-61-23.3-84.2,0h0c-23.3,23.2-23.3,60.9,0,84.2,0,0,0,0,0,0l240.1,240.1c11.2,11.2,26.3,17.5,42.1,17.4,15.8,0,30.9-6.3,42.1-17.4,23.2-23.3,23.2-60.9,0-84.2l-240.1-240.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147221",
    className: "st0",
    d: "M261.5,504.3L21.4,744.3c-23.3,23.3-23.3,61,0,84.2,0,0,0,0,0,0,11.2,11.2,26.3,17.4,42.1,17.4,15.8,0,31-6.3,42.1-17.4l240-240.1c23.3-23.3,23.3-61,0-84.2-23.3-23.2-61-23.2-84.2,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147222",
    className: "st0",
    d: "M546.4,363.2c15.8,0,31-6.3,42.1-17.4l240.1-240.1c23.2-23.2,23.3-60.9,0-84.2,0,0,0,0,0,0-23.2-23.3-60.9-23.3-84.2,0,0,0,0,0,0,0l-240.1,240.1c-23.2,23.2-23.3,60.9,0,84.1,0,0,0,0,0,0,11.1,11.2,26.3,17.5,42.1,17.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147223",
    className: "st0",
    d: "M105.7,21.4c-23.3-23.3-61-23.3-84.2,0-23.3,23.3-23.3,61,0,84.2l240.1,240.1c11.2,11.2,26.3,17.5,42.1,17.4,15.8,0,30.9-6.3,42.1-17.4,23.3-23.2,23.3-60.9,0-84.2,0,0,0,0,0,0L105.7,21.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147224",
    className: "st0",
    d: "M425,364.9c-33.1,0-60,26.9-60,60h0c0,33.2,26.9,60,60,60h0c33.1,0,60-26.8,60-60h0c0-33.2-26.8-60-60-60h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnyxXBlue);
export default __webpack_public_path__ + "static/media/ONYX - X - blue.04301b8a77c680f1cfcbc47954a30bdf.svg";
export { ForwardRef as ReactComponent };